const POPUP_FORMS = new Set([
  "General Enquiry",
  "Coaching Enquiry",
  "Venue Enquiry",
  "Booking Enquiry - Early",
  "Booking Enquiry - Standard",
  "Retreat Enquiry - Early",
  "Retreat Enquiry - Standard",
])

const POPUP_FORM_EVENT_LABELS = {
  "General Enquiry": "general_enquiry_popup",
  "Coaching Enquiry": "coaching_enquiry_popup",
  "Venue Enquiry": "venue_enquiry_popup",
  "Booking Enquiry - Early": "book_now_popup",
  "Booking Enquiry - Standard": "book_now_popup",
  "Retreat Enquiry - Early": "book_now_popup",
  "Retreat Enquiry - Standard": "book_now_popup",
}

export const isTrackedPopupForm = formName => POPUP_FORMS.has(formName)

export const getPopupFormEventLabel = formName =>
  POPUP_FORM_EVENT_LABELS[formName] || "popup_form"

export const trackGtagEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return
  }

  window.gtag("event", eventName, params)
}

export const trackPopupFormStart = formName => {
  trackGtagEvent("form_start", {
    event_category: "form",
    event_label: getPopupFormEventLabel(formName),
    form_name: formName,
  })
}

export const trackPopupFormSubmit = formName => {
  trackGtagEvent("form_submit", {
    event_category: "form",
    event_label: getPopupFormEventLabel(formName),
    form_name: formName,
  })
}
